import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CertificatesRoutingModule } from "./certificates-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { CoreModule } from "../core/core.module";

import { CertificatesComponent } from "./certificates.component";
import { MailboxComponent } from "./mailbox/mailbox.component";
import { ListMailboxComponent } from "./mailbox/list-mailbox/list-mailbox.component";
import { QueryComponent } from "./query/query.component";
import { RequestComponent } from "./request/request.component";
import { DetailMailboxComponent } from "./mailbox/detail-mailbox/detail-mailbox.component";
import { ResquestCertificateDataComponent } from "./request/resquest-certificate-data/resquest-certificate-data.component";

import { ListQueryComponent } from "./query/list-query/list-query.component";

@NgModule({
  declarations: [
    CertificatesComponent,
    MailboxComponent,
    ListMailboxComponent,
    QueryComponent,
    RequestComponent,
    DetailMailboxComponent,
    ResquestCertificateDataComponent,
    ListQueryComponent,
  ],
  imports: [
    CommonModule,
    CertificatesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    CoreModule,
  ],
  exports: [],
})
export class CertificatesModule {}
